export const ADMIN_DETAIL = 'ADMIN_DETAIL';
export const ADMIN_TOKEN = 'ADMIN_TOKEN';
export const SIDE_LIST_DATA = "SIDE_LIST_DATA";
export const OTHER_USER_DATA = "OTHER_USER_DATA";
export const OTHER_USER_DATA_CHAT = "OTHER_USER_DATA_CHAT";
